import React from 'react';
import "./SectionWrapper.scss"
const SectionWrapper = ({ children }) => {
  return (
    <>
      <div className="section-enterprise">
        {children}
      </div>
    </>
  );
};

export default SectionWrapper;